// Public descriptions only. Prompts and source templates stay on the server.
export interface FeatureInput {
    id: string; label: string; source: string; type: string; required: boolean;
    help: string; options: string[]; max_length: number;
}
export interface Feature {
    id: string; name: string; description: string; detail: string; format: string; input: string;
    prompt_version: string; release_hash: string; inputs: FeatureInput[];
    questions: { id: string; input_ref: string; label: string }[];
    chapters: string[]; output: any; output_schema: any; execution_available: false;
}
export const EMPTY_FEATURE: Feature = {
    id: '', name: '', description: '', detail: '', format: '', input: '', prompt_version: '', release_hash: '',
    inputs: [], questions: [], chapters: [], output: { type: 'body', sections: [], perspectives: [] },
    output_schema: {}, execution_available: false
};
export async function loadFeatures(): Promise<Feature[]> {
    const response = await fetch('/api/saju/profiles/features', { cache: 'no-store' });
    if (!response.ok) throw new Error('기능 목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
    return (await response.json()).data;
}

export class FeatureInputs {
    public answers: Record<string, string> = Object.create(null);
    public prepared: any = null;
    public message = '';
    public busy = false;
    private serial = 0;
    private key = '';
    private drafts: Record<string, Record<string, string>> = Object.create(null);
    bind(feature: Feature, selected: any) {
        const key = selected ? [selected.profile.id, selected.revision.id, feature.id].join(':') : '';
        if (key === this.key) return;
        this.serial++; this.key = key;
        this.answers = key ? { ...(this.drafts[key] || {}) } : Object.create(null);
        this.prepared = null; this.message = ''; this.busy = false;
    }
    leave() { this.serial++; this.prepared = null; this.message = ''; this.busy = false; }
    clear(all = false) {
        this.serial++; this.answers = Object.create(null); this.prepared = null; this.busy = false;
        if (all) { this.drafts = Object.create(null); this.key = ''; this.message = ''; return; }
        if (this.key) delete this.drafts[this.key];
        this.message = '작성한 내용을 지웠습니다.';
    }
    edit(id: string, value: string) {
        this.serial++; this.answers[id] = value;
        if (this.key) this.drafts[this.key] = { ...this.answers };
        this.prepared = null; this.message = ''; this.busy = false;
    }
    get hasContent() { return Object.values(this.answers).some(value => value.trim().length > 0); }
    async check(feature: Feature, selected: any, request: (body: any) => Promise<any>) {
        const serial = ++this.serial;
        this.prepared = null; this.message = ''; this.busy = true;
        try {
            const data = await request({ feature_id: feature.id, release_hash: feature.release_hash,
                profile_id: selected.profile.id, revision_id: selected.revision.id, answers: { ...this.answers } });
            if (serial !== this.serial) return;
            this.prepared = data;
            this.message = data.run_input.readiness === 'blocked' ? '필수 입력을 확인해 주세요.' : '이번 풀이에 사용할 입력을 확인했습니다. 실행 요청은 아래 버튼에서 진행합니다.';
        } catch (error: any) {
            if (serial === this.serial) this.message = error.message || '입력을 확인하지 못했습니다. 다시 시도해 주세요.';
        } finally { if (serial === this.serial) this.busy = false; }
    }
}
